module.exports = __webpack_public_path__ + "media/images/応援ハシゴ割引_500円_1280_480-43efcf4e7181cffc6ee6692adb736b84.png";